<template>
    <div style="padding-right: 1px" class="pa-4 page-settings theme--light">
        <div class="d-flex flex-wrap justify-space-between align-center mb-4" style="gap: 16px;">
            <div class="d-flex flex-column justify-center flex-grow-1">
                <div class="text-h5 font-weight-bold">
                    {{$translate('Manage pages')}}
                </div>
                <div class="text-subtitle-1">
                    {{$translate('Choose a page for your website')}}
                </div>
            </div>
            <v-btn
                @click="showAddPageDialog = true"
                color="zoezi-edit-color"
                class="pa-3 my-3 text-subtitle-1 flex-shrink-0"
            >
                {{$translate('Create page')}}
                <v-icon right>mdi-plus-thick</v-icon>
            </v-btn>
        </div>
        <v-text-field v-model="search" :label="$translate('Search')" append-icon="mdi-magnify" single-line hide-details color="zoezi-edit-color" clearable />
        <v-list>
            <v-list-item
                v-for="route in sortedRoutes"
                :key="route.path"
                class="route-list-item ps-4"
                :to="route.path"
                @click="handleRouteClick(route)"
                link
                exact
                active-class="route-list-item--active"
            >
                <v-list-item-icon v-if="route.redirect">
                    <v-icon>mdi-redo</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    {{$translate(route.name)}}
                </v-list-item-content>
                <v-list-item-action
                    v-if="canRemoveRoute(route)"
                    class="route-list-item__delete ma-0 py-3"
                >
                    <v-btn
                        color="error"
                        fab
                        small
                        @click.stop.prevent="removePage(route)"
                    >
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
        </v-list>

        <add-page v-model="showAddPageDialog" />
    </div>
</template>

<script>
import AddPage from './AddPage.vue'
export default {
    name: 'PageSettings',

    components: {
        AddPage
    },

    data: () => ({
        currentPanel: 0,
        showAddPageDialog: false,
        search: '',
        lastClickedRoutePath: null,
    }),
    computed: {
        sortedRoutes() {
            const s = (this.search || '').toLowerCase();
            const sorted = this.$root.siteconfig.routes
                .map(r => r.props)
                .filter(r => !s || r.path.includes(s) || r.name.toLowerCase().includes(s))
                .sort((a, b) => a.name.localeCompare(b.name));

            if (this.lastClickedRoutePath) {
                const index = sorted.findIndex(route => route.path === this.lastClickedRoutePath);
                if (index) {
                    const [clickedRoute] = sorted.splice(index, 1);
                    sorted.unshift(clickedRoute);
                }
            }

            return sorted;
        },
    },
    methods: {
        handleRouteClick(route) {
            this.lastClickedRoutePath = route.path;
        },
        canRemoveRoute(route) {
            return route.path !== '/';
        },
        removePage(routeProps = this.$route) {
            const targetPath = routeProps.path;
            const targetName = routeProps.name;
            const index = this.$root.siteconfig.routes.map(r => r.props).findIndex(x => x.path == targetPath);

            // Creates a map of redirect -> paths, {'/': ['/home', '/page2'], '/page1': ['/mypage']}
            const redirectRouteMap = this.$root.siteconfig.routes.reduce((redirectMap, { props: { redirect, path } }) => {
                if (!redirect) return redirectMap;
                redirectMap[redirect] = redirectMap[redirect] || [];
                redirectMap[redirect].push(path);
                return redirectMap;
            }, {});

            if (redirectRouteMap[targetPath]) {
                const pagesNames = this.$root.siteconfig.routes
                    .filter(r => redirectRouteMap[targetPath].includes(r.props.path))
                    .map(r => `\n ${r.props.name} (${r.props.path})`)

                this.$store.commit('showErrorDialog', {
                    title: this.$translate("Cannot remove page"),
                    text: this.$translate('The page {0} is used as a redirect for the following pages: {1}').format(
                        targetPath,
                        pagesNames.join(', ')
                    ),
                });
                return;
            }

            if (index != -1) {
                this.$store.commit('showConfirmDialog', {
                    title: this.$translate('Remove page'),
                    text: this.$translate('Are you sure you want to remove the page {0}?').format(`${targetName} (${targetPath})`),
                    actionText: this.$translate('Delete'),
                    actionColor: 'error',
                    action: () => {
                        this.$root.siteconfig.routes.splice(index, 1);
                        this.$root.saveHomePage();

                        if (this.$route.path === targetPath) {
                            this.$root.followLink('/');
                        }
                    }
                });
            }
        },
    },
}
</script>

<style scoped>
.route-list-item {
    transition: background-color 0.2s ease;
    border-radius: 4px;
}

.route-list-item:hover {
    background-color: rgba(0, 0, 0, 0.04);
}

.route-list-item--active {
    background-color: transparent;
    color: var(--z-zoezi-edit-color, #1976d2);
}

.route-list-item--active:hover {
    background-color: transparent;
}

.route-list-item__delete {
    opacity: 0;
    transition: opacity 0.2s ease;
}

.route-list-item--active .route-list-item__delete,
.route-list-item__delete:focus-within {
    opacity: 1;
}

.page-settings {
    color: rgba(0, 0, 0, 0.87);
}

.page-settings .text-subtitle-1 {
    color: rgba(0, 0, 0, 0.6);
}
</style>
